export const HOME_ROUTE = "/";
export const GUEST_LOGIN_ROUTE = "/guest_login"
export const ADMIN_LOGIN_ROUTE = "/admin_login"
export const THREAD_DETAIL_ROUTE = "/thread/:id"